import { datadogRum } from '@datadog/browser-rum';
import type { AnalyticsInstance } from 'analytics';

type AnalyticsWindowT = { analytics?: AnalyticsInstance; } & Window;

declare let window: AnalyticsWindowT;

// Sends a custom action to Datadog RUM and to the app's `analytics` instance (Adobe), which each app
// exposes on `window.analytics`. The two sends are independent: each is a no-op when its destination
// isn't set up, so neither relies on the other being enabled.
export const trackAction = (name: string, context?: Record<string, unknown>): void => {
  datadogRum.addAction(name, context);
  window.analytics?.track(name, context);
};
